var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isExpired)?_c('login-component',{attrs:{"msj":2},on:{"login":function($event){_vm.login = $event}}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }